import {LoginForm} from "./LoginForm";
import styled from "styled-components";

export const Login = () => {
  return (
      <Container>
        <LoginForm />
      </Container>
  )
}

const Container = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`
